// Field config for the FilterableList on the /policies Bound tab. Mirrors List/fields but with the
// tab's own 6 filters and 8 columns. FilterableList owns layout, summary, Clear gating.

// Sort-bar columns for ColumnSortBar. One span per column (set on xs, inherited to lg); spans sum to
// 12. `category` picks the icon (alpha = A-Z, date = directional); `columnName` is the sort key.
// Column headers reuse the List tab's Policies_List.table.* ids so all three tabs show identical
// header text (e.g. "Reference #", "Policy #") from one source.
export const BOUND_COLUMNS = [
    { labelId: 'Policies_List.table.referenceNumber', xs: 1.5 },
    {
        labelId: 'Policies_List.table.policyNumber',
        columnName: 'policyNumber',
        sortable: true,
        category: 'alpha',
        xs: 1.5,
    },
    { labelId: 'Policies_List.table.insuredName', columnName: 'insuredName', sortable: true, category: 'alpha', xs: 3 },
    { labelId: 'Policies_List.table.product', xs: 1.5 },
    {
        labelId: 'Policies_List.table.creationDate',
        columnName: 'creationDate',
        sortable: true,
        category: 'date',
        xs: 1.5,
    },
    { labelId: 'Policies_List.table.assignedTo', xs: 2 },
    { labelId: 'Policies_List.table.type', xs: 1 },
];

export const BOUND_FIELDS = [
    {
        code: 'brokerReferenceGuid',
        type: 'dropdown',
        label: 'Policies_Bound.search.assignedTo',
        reference: 'ActiveBrokers',
        allLabel: 'Policies_Bound.search.allBrokers',
    },
    {
        code: 'product',
        type: 'dropdown',
        label: 'Policies_Bound.table.product',
        optionsFrom: 'products',
        allLabel: 'Policies_Bound.search.allProducts',
    },
    { code: 'clientFirstName', type: 'input', label: 'Policies_Bound.table.fname' },
    { code: 'clientLastName', type: 'input', label: 'Policies_Bound.table.lname' },
    { code: 'clientPhoneFullNumber', type: 'input', label: 'Policies_Bound.search.phone' },
    { code: 'clientEmail', type: 'input', label: 'Policies_Bound.search.email' },
];
